import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { SnExpandIconComponent } from './components/expand-icon/expand-icon.component';
import { SnFususIconComponent } from './components/fusus-icons/fusus-icons.component';
import { SnIconComponent } from './components/icon/icon.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Material
    MatIconModule,
  ],
  exports: [
    // Components
    SnIconComponent,
    SnFususIconComponent,
    SnExpandIconComponent,
  ],
  declarations: [
    // Components
    SnIconComponent,
    SnFususIconComponent,
    SnExpandIconComponent,
  ],
})
export class SnIconModule {}
